import { useState, useEffect} from "react";
import { searchclosedTripsbyDate, fetchDest, fetchpotentialdata, fetchCustomerbyDate, searchallTripsbyDate, searchLeadsbyDate, searchconvTripsbyStartDate, fetchTripsbyNumber, fetchcustbydob, fetchconvcustdata, searchboTripsbyDate, fetchmarketingcustlist, searchTripsbyDate2, fetchmarketingcustlist2, fetchCustomerbyNumber, searchhotTripsbyDate, fetchQuotebyId, searchconvTripsbyDate, fetchacceptedtripsbydate, ggwacampaign, ggwacampaign3, searchDABTripsbyDate, searchcancelledTripsbyDate, searchConvTripsbyStartDate, fetchreviewhotel, fetchtripsbyairport, ggwacampaign4, fetchSuppliers, fetchmarketingcustlist3, fetchmarketingcustlist4, searchLeadsbyDate3
} from "../api/customerapi";
import {preventDoubleClick} from "./preventDC.js"
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {CSVLink} from "react-csv"
import GetRole from "./user";
import Loading from "./loading";
import DateCalc, {getmonthtext, getquality, getSumByKey2, total, getconvdate, DateCalc2, getmonth, removeObjectsWithSameKeyValue, removeDuplicates, gethotdate, getprofit, getstate, airportlist, pending, upsellprofittotal} from "./date";

import {
    Paper,
    FormControl,
    Button,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Typography,
  } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
  })); 
const Marketing = () => {
    const classes = useStyles();
    const width = window.innerWidth - 200;
    const columns = [
        
      {
        field: "name",
        headerName: " Name",
        width: width / 12,
        cellClassName: "gridcell",
      },{
          field: "owner",
          headerName: " Owner",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
            field: "trip_id",
            headerName: "Trip Id",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "mobile_number",
            headerName: "Mobile",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "email",
            headerName: "Email",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "destination",
            headerName: "Destination",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "start_date",
            headerName: "Start Date",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "status",
            headerName: "Status",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "review",
            headerName: "Review",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "first_payment",
            headerName: "Conv Date",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "ops_owner",
            headerName: "Owner",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "revenue",
            headerName: "Revenue",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "pax",
            headerName: "Pax",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "tl",
            headerName: "Sales TL",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "createdAt",
            headerName: "Created At",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "time_to_convert",
            headerName: "Convert Time To",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "upsell_value",
            headerName: "Upsell Value",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "upsell_profit",
            headerName: "Upsell Profit",
            width: width / 12,
            cellClassName: "gridcell",
          },
      ];

      const columns4 = [
        
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },{
            field: "owner",
            headerName: " Owner",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
              field: "trip_id",
              headerName: "Trip Id",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "mobile_number",
              headerName: "Mobile",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "destination",
              headerName: "Destination",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "source",
              headerName: "Channel",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "previous_status",
              headerName: "Prev. Status",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "start_date",
              headerName: "Start Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "canc_reason_short",
              headerName: "Reason",
              width: width / 12*2,
              cellClassName: "gridcell",
            },
            {
              field: "canc_reason",
              headerName: "Details",
              width: width / 12*2,
              cellClassName: "gridcell",
            },
            
           
        ];
      const columns2 = [
        {
          field: "owner",
          headerName: "Lead Owner",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: "Name",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
            field: "lead_id",
            headerName: "Lead Id",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "platform",
            headerName: "Platform",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "campaign",
            headerName: "Campaign",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "work_complete_date",
            headerName: "Work Done Date",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "destination",
            headerName: "Destination",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "start_date",
            headerName: "Start Date",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "createdAt_date",
            headerName: "Created At",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "createdAt_time",
            headerName: "Time",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "lead_canc",
            headerName: "Canc Reason",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
            field: "lead_canc_reason",
            headerName: "Canc Reason",
            width: width / 12,
            cellClassName: "gridcell",
          },
      ];
      const columns3 = [
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },{
            field: "owner",
            headerName: " Owner",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
              field: "trip_id",
              headerName: "Trip Id",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "mobile_number",
              headerName: "Mobile",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "email",
              headerName: "Email",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "destination",
              headerName: "Destination",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "start_date",
              headerName: "Start Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "status",
              headerName: "Status",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "conv_date",
              headerName: "Conv Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "ops_owner",
              headerName: "Ops Owner",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "channel",
              headerName: "Channel",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "profit",
              headerName: "Profit",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "total",
              headerName: "Total",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "pending",
              headerName: "Pending",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "flight_sp",
              headerName: "FlightSP",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "sc",
              headerName: "SC",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "of",
              headerName: "OF",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "pd",
              headerName: "Proxy Dom",
              width: width / 12,
              cellClassName: "gridcell",
            },
            
      ];
      const columns13 = [
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },{
            field: "owner",
            headerName: " Owner",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
              field: "trip_id",
              headerName: "Trip Id",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "mobile_number",
              headerName: "Mobile",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "email",
              headerName: "Email",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "destination",
              headerName: "Destination",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "start_date",
              headerName: "Start Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "status",
              headerName: "Status",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "canc_date",
              headerName: "Canc Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "ops_owner",
              headerName: "Ops Owner",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "channel",
              headerName: "Channel",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "canc_reason",
              headerName: "Canc Reason",
              width: width / 12*2,
              cellClassName: "gridcell",
            },
           
            
      ];

      const ccolumns = [
        {
          field: "cust_id",
          headerName: " Cust Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "dob",
          headerName: " DOB",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "cust_city",
          headerName: " City",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "chat_mobile",
          headerName: " Chat No.",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "cust_anniversary",
          headerName: "Anniversary",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "email",
          headerName: "Email",
          width: width / 12,
          cellClassName: "gridcell",
        },
            
      ];
      const columns5 = [
        {
          field: "trip_id",
          headerName: " Trip Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "owner",
          headerName: "Owner",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
        {
          field: "name",
          headerName: " Name",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        
        {
          field: "chat_mobile",
          headerName: " Chat No.",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "destination",
          headerName: "Destination",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "email",
          headerName: "Email",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "status",
          headerName: "Status",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "start_date",
          headerName: "Start Date",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "quality",
          headerName: "Quality",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "adult",
          headerName: "Adults",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "child",
          headerName: "Child",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "current_note",
          headerName: "CN",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "prev_note",
          headerName: "PN",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "cp",
          headerName: "CP",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "sp",
          headerName: "SP",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "profit",
          headerName: "Profit",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "profit_perc",
          headerName: "Profit %",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "quote_id",
          headerName: "Quote Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "channel",
          headerName: "Channel",
          width: width / 12,
          cellClassName: "gridcell",
        },
            
      ];

      const columns6 = [
        {
          field: "closed",
          headerName: " Closed Trips",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "number_review",
          headerName: "Reviews",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "internal_number_review",
          headerName: "Internal Reviews",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "pt_prom",
          headerName: "PT Prom",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "pt_det",
          headerName: "PT Det",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "pt_neutral",
          headerName: "PT Neutral",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
        {
          field: "pt_nps",
          headerName: "PT NPS",
          width: width / 12,
          cellClassName: "gridcell",
        },
       {
          field: "rnt",
          headerName: "RNT",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "rnt_genuine",
          headerName: "RNT Genuine",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "rng",
          headerName: "RNG",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "pending",
          headerName: "Pending",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "ps_prom",
          headerName: "PS Prom",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "ps_det",
          headerName: "PS Det",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "ps_neutral",
          headerName: "PS Neutral",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
        {
          field: "ps_nps",
          headerName: "PS NPS",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "review_score",
          headerName: "5 star",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "review_score_perc",
          headerName: "5 star/Promoters",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "fair_nps",
          headerName: "Fair NPS",
          width: width / 12,
          cellClassName: "gridcell",
        },
            
      ];
      const ccolumns2 = [
        {
          field: "cust_id",
          headerName: " Cust Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        
        {
          field: "cust_city",
          headerName: " City",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "cust_state",
          headerName: "State",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "chat_mobile",
          headerName: " Chat No.",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
        {
          field: "email",
          headerName: "Email",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "cust_mm",
          headerName: "Mktng. Msg.",
          width: width / 12,
          cellClassName: "gridcell",
        },
            
      ];
      const ccolumns3 = [
        {
          field: "cust_id",
          headerName: " Cust Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        
        
        {
          field: "chat_mobile",
          headerName: " Chat No.",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "trip_id",
          headerName: " Trip Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "destination",
          headerName: "Destination",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "month",
          headerName: "Month",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
            
      ];
      const ccolumns4 = [
        {
          field: "cust_id",
          headerName: " Cust Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        
        
        {
          field: "chat_mobile",
          headerName: " Chat No.",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "trip_id",
          headerName: " Trip Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "destination",
          headerName: "Destination",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "month",
          headerName: "Month",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
            
      ];
      const ccolumns12 = [
        {
          field: "cust_id",
          headerName: " Cust Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
        
       
        {
          field: "th",
          headerName: "Travel History",
          width: width / 12*3,
          cellClassName: "gridcell",
        },
        {
          field: "demo",
          headerName: "Demo",
          width: width / 12*3,
          cellClassName: "gridcell",
        },
        {
          field: "notes",
          headerName: "Notes",
          width: width / 12*3,
          cellClassName: "gridcell",
        },
        
            
      ];
      const ccolumns15 = [
       
        {
          field: "name",
          headerName: " Name",
          width: width / 12*3,
          cellClassName: "gridcell",
        },
        {
          field: "number",
          headerName: "Mobile",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
         {
          field: "dest",
          headerName: "Destination",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "email",
          headerName: "Email",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        
        
       
      
        
            
      ];
      const columns11 = [
        {
          field: "trip_id",
          headerName: "Trip Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: "Name",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "owner",
          headerName: "Owner",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "tl",
          headerName: "TL",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "status",
          headerName: "Status",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "trip_start_date",
          headerName: "Start Date",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "destination",
          headerName: "Destination",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "quote",
          headerName: "Quote",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "createdAt",
          headerName: "Created",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "hotAt",
          headerName: "Hot Marked",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "convAt",
          headerName: "Conv Marked",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "cancAt",
          headerName: "Canc Mark",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
         {
          field: "accepted_date",
          headerName: "Accepted",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
         {
          field: "hotel_booking_date",
          headerName: "Hotel Book",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
         {
          field: "land_booking_date",
          headerName: "Land Book",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
         {
          field: "voucher_matched_date",
          headerName: "VM",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "time_to_convert",
          headerName: "Time to Convert",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "time_to_hot",
          headerName: "Time to Hot",
          width: width / 12,
          cellClassName: "gridcell",
        },   
        {
          field: "time_to_accept",
          headerName: "Time to Accept",
          width: width / 12,
          cellClassName: "gridcell",
        }, 
        {
          field: "time_to_book_hotel",
          headerName: "Time to Hotel",
          width: width / 12,
          cellClassName: "gridcell",
        }, 
        {
          field: "time_to_book_land",
          headerName: "Time to Land",
          width: width / 12,
          cellClassName: "gridcell",
        }, 
        {
          field: "time_to_vm",
          headerName: "Time to VM",
          width: width / 12,
          cellClassName: "gridcell",
        },  
        {
          field: "lead_destination",
          headerName: "Lead Dest",
          width: width / 12,
          cellClassName: "gridcell",
        }, 
        {
          field: "trip_destination",
          headerName: "Trip Dest",
          width: width / 12,
          cellClassName: "gridcell",
        }, 
        {
          field: "lead_id",
          headerName: "Lead Id",
          width: width / 12,
          cellClassName: "gridcell",
        }, 
        {
          field: "booking_status",
          headerName: "Booking Status",
          width: width / 12,
          cellClassName: "gridcell",
        },
         {
          field: "hold_ops",
          headerName: "Hold Ops",
          width: width / 12,
          cellClassName: "gridcell",
        },
      ];
      const columns12 = [
        {
          field: "trip_id",
          headerName: "Trip Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
                {
          field: "destination",
          headerName: "Destination",
          width: width / 12,
          cellClassName: "gridcell",
        },
          
        {
          field: "trip_end_date",
          headerName: "End Date",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "pt_score",
          headerName: "PT Score",
          width: width / 12*0.75,
          cellClassName: "gridcell",
        },
        {
          field: "attempt",
          headerName: "Attempts",
          width: width / 12*0.75,
          cellClassName: "gridcell",
        },
        {
          field: "fup",
          headerName: "FUP",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "cust_comment",
          headerName: "Feedback",
          width: width / 12*5,
          cellClassName: "gridcell",
          renderCell: (params) => (
            <Box sx={{ whiteSpace: "normal", wordWrap: "break-word", overflow: "visible", lineHeight: "1.5", }}>
              {params.value}
            </Box>
          ),
        },
        {
          field: "analysis",
          headerName: "Analysis",
          width: width / 12*5,
          cellClassName: "gridcell",
        },
        {
          field: "supplier",
          headerName: "Supplier",
          width: width / 12*2,
          cellClassName: "gridcell",
        },
        {
          field: "supplier_issue",
          headerName: "Supplier Issue",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "trip_owner",
          headerName: "Trip Owner",
          width: width / 12,
          cellClassName: "gridcell",
        },
           
      ];
      const columns14 = [
        {
          field: "trip_id",
          headerName: "Trip Id",
          width: width / 12,
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },
        
                {
          field: "destination",
          headerName: "Destination",
          width: width / 12,
          cellClassName: "gridcell",
        },
          
        
        {
          field: "pt_score",
          headerName: "PT Score",
          width: width / 12*0.75,
          cellClassName: "gridcell",
        },
        {
          field: "hotel_name",
          headerName: "Hotel",
          width: width / 12,
          cellClassName: "gridcell",
        },
       
        {
          field: "cust_comment",
          headerName: "Feedback",
          width: width / 12*5,
          cellClassName: "gridcell",
          renderCell: (params) => (
            <Box sx={{ whiteSpace: "normal", wordWrap: "break-word", overflow: "visible", lineHeight: "1.5", }}>
              {params.value}
            </Box>
          ),
        },
        
        
           
      ]
      const columns15 = [
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },{
            field: "owner",
            headerName: " Owner",
            width: width / 12,
            cellClassName: "gridcell",
          },
          {
              field: "trip_id",
              headerName: "Trip Id",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "mobile_number",
              headerName: "Mobile",
              width: width / 12,
              cellClassName: "gridcell",
            },
          
            {
              field: "destination",
              headerName: "Destination",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "start_date",
              headerName: "Start Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
           
            {
              field: "conv_date",
              headerName: "Conv Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "pt_score",
              headerName: "PT Score",
              width: width / 12,
              cellClassName: "gridcell",
            },
           
            
      ];
      const columns20 = [
        {
          field: "name",
          headerName: " Name",
          width: width / 12,
          cellClassName: "gridcell",
        },
          {
              field: "trip_id",
              headerName: "Trip Id",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "status",
              headerName: "Status",
              width: width / 12,
              cellClassName: "gridcell",
            },
          
            {
              field: "destination",
              headerName: "Destination",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "accepted_date",
              headerName: "Accepted Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
           
            {
              field: "bc",
              headerName: "BC",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "hp",
              headerName: "HP",
              width: width / 12,
              cellClassName: "gridcell",
            },
           {
              field: "jc_date",
              headerName: "JC Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
             {
              field: "ops_owner",
              headerName: "Ops Owner",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "callrecord",
              headerName: "Call Record",
              width: width / 12,
              cellClassName: "gridcell",
            },
            
      ];
       const airportlist2=airportlist.sort((a, b) => (a.city > b.city) ? 1: -1);
      
    const [searchData, setsearchData] = useState([{}]);
    const [searchData2, setsearchData2] = useState([{}]);
    const [searchData3, setsearchData3] = useState([{}]);
    const [searchData4, setsearchData4] = useState([{}]);
    const [searchData5, setsearchData5] = useState([{}]);
    const [searchData6, setsearchData6] = useState([{}]);
    const [searchData7, setsearchData7] = useState([{}]);
    const [searchData8, setsearchData8] = useState([{}]);
    const [searchData9, setsearchData9] = useState([{}]);
    const [searchData10, setsearchData10] = useState([{}]);
    const [searchData11, setsearchData11] = useState([{}]);
    const [searchData14, setsearchData14] = useState([{}]);
    const [searchData12, setsearchData12] = useState([{}]);
    const [searchData15, setsearchData15] = useState([{}]);
    const [searchData16, setsearchData16] = useState([{}]);
    const [searchData17, setsearchData17] = useState([{}]);
    const [searchData18, setsearchData18] = useState([{}]);
    const [searchData19, setsearchData19] = useState([{}]);
    const [searchData28, setsearchData28] = useState([{}]);
    const [dest, setdest] = useState([]);
    const [empops, setempops] = useState([]);
    const [emp, setemp] = useState([]);
    const [listclosedtripData, setlistclosedtripData] = useState([{}]);
    const [closedtripData, setclosedtripData] = useState([]);
    const [listcustData, setlistcustData] = useState([]);
    const [listcustData2, setlistcustData2] = useState([]);
    const [listcustData3, setlistcustData3] = useState([]);
    const [listcustData4, setlistcustData4] = useState([]);
    const [acceptedtrips, setacceptedtrips] = useState([{}]);
    const [listcanctripData, setlistcanctripData] = useState([{}]);
    const [listcanctripData2, setlistcanctripData2] = useState([{}]);
    const [listtripairportData, setlisttripairportData] = useState([{}]);
    const [listcanceltripData, setlistcanceltripData] = useState([{}]);
    const [listconvtripData, setlistconvtripData] = useState([]);
    const [listreviewtripData, setlistreviewtripData] = useState([]);
    const [convtripData, setconvtripData] = useState([]);
    const [listactivetripData, setlistactivetripData] = useState([{}]);
    const [listcreatedtripData, setlistcreatedtripData] = useState([{}]);
    const [leadfilterData, setleadfilterData] = useState([{}]);
    const [listbotripData, setlistbotripData] = useState([{}]);
    const [listleadData, setlistleadData] = useState([{}]);
    const [listleadData2, setlistleadData2] = useState([{}]);
    const [marketingcustlist, setmarketingcustlist] = useState([]);
    const [reviewfilter, setreviewfilter] = useState(null);
    const [marketingcustlist2, setmarketingcustlist2] = useState([]);
    const [marketingcustlist3, setmarketingcustlist3] = useState([]);
    const [working, setworking]=useState(false);
     const [sData, setsData] = useState([{all_good:false}]);
     const { cuser, role, employeelist, destinationlist, loading } = GetRole(); 

      const headers=[
        {label:"Owner", key:"owner"},
        {label:"Name", key:"name"},
        {label:"Trip Id", key:"trip_id"},
        {label:"Mobile Number", key:"mobile_number"},
        {label:"Email", key:"email"},
        {label:"Destination", key:"destination"},
        {label:"Start Date", key:"start_date"},
        {label:"Status", key:"status"},
        {label:"Review", key:"review"},
        {label:"Ops Owner", key:"ops_owner"},
        {label:"Revenue", key:"revenue"},
        {label:"Pax", key:"pax"},
        {label:"TL", key:"tl"},
        {label:"Conv Date", key:"first_payment"},
        {label:"Created At", key:"createdAt"},
        {label:"Diff", key:"time_to_convert"},
    ]
    const headers4=[
      {label:"Owner", key:"owner"},
      {label:"Name", key:"name"},
      {label:"Trip Id", key:"trip_id"},
      {label:"Mobile Number", key:"mobile_number"},
      {label:"Destination", key:"destination"},
      {label:"Channel", key:"source"},
      {label:"Previous Status", key:"previous_status"},
      {label:"Start Date", key:"start_date"},
      {label:"Reason", key:"trip_canc_reason"},
      {label:"Details", key:"trip_canc_reason_short"},
  ]
    const headers3=[
      {label:"Owner", key:"owner"},
      {label:"Name", key:"name"},
      {label:"Trip Id", key:"trip_id"},
      {label:"Mobile Number", key:"mobile_number"},
      {label:"Email", key:"email"},
      {label:"Destination", key:"destination"},
      {label:"Start Date", key:"start_date"},
      {label:"Status", key:"status"},
      {label:"Conv Date", key:"conv_date"},
      {label:"Ops Owner", key:"ops_owner"},
      {label:"Channel", key:"channel"},
      {label:"Pax", key:"pax"},
      {label:"Profit", key:"profit"},
      {label:"Total", key:"total"},
      {label:"Pending", key:"pending"},
      {label:"Flight SP", key:"flight_sp"},
      {label:"OF", key:"of"},
      {label:"SC", key:"sc"},
      {label:"PD", key:"pd"},
  ]
  const headers13=[
    {label:"Owner", key:"owner"},
    {label:"Name", key:"name"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Mobile Number", key:"mobile_number"},
    {label:"Email", key:"email"},
    {label:"Destination", key:"destination"},
    {label:"Start Date", key:"start_date"},
    {label:"Status", key:"status"},
    {label:"Canc Date", key:"canc_date"},
    {label:"Ops Owner", key:"ops_owner"},
    {label:"Channel", key:"channel"},
    {label:"Pax", key:"pax"},
    {label:"Canc Reason", key:"canc_reason"},
]
const headers15=[
  
    {label:"name", key:"name"},
   {label:"number", key:"number"},
   {label:"email", key:"email"},
     {label:"dest", key:"dest"},
]
  const headers5=[
    {label:"Owner", key:"owner"},
    {label:"Name", key:"name"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Mobile Number", key:"chat_mobile"},
    {label:"Email", key:"email"},
    {label:"Destination", key:"destination"},
    {label:"Start Date", key:"start_date"},
    {label:"Status", key:"status"},
    {label:"Adults", key:"adult"},
    {label:"Child", key:"child"},
    {label:"Quality", key:"quality"},
    {label:"CN", key:"current_note"},
    {label:"PN", key:"prev_note"},
    {label:"CP", key:"cp"},
    {label:"SP", key:"sp"},
    {label:"Profit", key:"profit"},
    {label:"Profit %", key:"profit_perc"},
    {label:"Quote Id", key:"quote_id"},
    {label:"Channel", key:"channel"},
]

const headers6=[
  {label:"Marketing Message", key:"cust_mm"},
  {label:"Name", key:"name"},
  {label:"Cust Id", key:"cust_id"},
  {label:"Mobile Number", key:"chat_mobile"},
  {label:"Email", key:"email"},
  {label:"State", key:"cust_state"},
  {label:"City", key:"cust_city"},
  
]

const headers11=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Dest", key:"destination"},
  {label:"Owner", key:"owner"},
  {label:"Tl", key:"tl"},
  {label:"Status", key:"status"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"Quote", key:"quote"},
  {label:"Created At", key:"createdAt"},
  {label:"Hot At", key:"hotAt"},
  {label:"Conv At", key:"convAt"},
  {label:"Canc At", key:"cancAt"},
  {label:"Time to Convert", key:"accepted_date"},
  {label:"Hotel Book", key:"hotel_booking_date"},
    {label:"Land Book", key:"land_booking_date"},
      {label:"VM", key:"voucher_matched_date"},
        {label:"Time to Hot", key:"time_to_hot"},
          {label:"Time to Convert", key:"time_to_convert"},
            {label:"Time to Accept", key:"time_to_accept"},
              {label:"Time to Hotel Book", key:"time_to_book_hotel"},
                {label:"Time to Land Book", key:"time_to_book_land"},
                  {label:"Time to VM from SD", key:"time_to_vm"},
                     {label:"Lead Dest", key:"lead_destination"},
                        {label:"Trip Dest", key:"trip_destination"},
                           {label:"Lead Id", key:"lead_id"},
                              {label:"Booking Status", key:"booking_status"},
                              {label:"Hold Ops", key:"hold_ops"},
]
const headers12=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Trip Owner", key:"trip_owner"},
  {label:"Name", key:"name"},
  {label:"Dest", key:"destination"},
  {label:"PT Score", key:"pt_score"},
  {label:"Feedback", key:"cust_comment"},
  {label:"Attempt", key:"attempt"},
  {label:"End Date", key:"trip_end_date"},
  {label:"Analysis", key:"analysis"},
  {label:"Supplier", key:"supplier"},
  {label:"Supplier Issue", key:"supplier_issue"},
]
const headers20=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Dest", key:"destination"},
  {label:"Briefing Call", key:"bc"},
  {label:"Hotel Pitch", key:"hp"},
  {label:"Status", key:"status"},
  {label:"JC Date", key:"jc_date"},
 {label:"Accepted Date", key:"accepted_date"},
]
  const cheaders=[
    {label:"Cust Id", key:"cust_id"},
    {label:"Name", key:"name"},
    {label:"DOB", key:"dob"},
    {label:"City", key:"cust_city"},
    {label:"Mobile", key:"chat_mobile"},
    {label:"Anniversary", key:"cust_anniversary"},
    {label:"Email", key:"email"},
]
const cheaders2=[
  {label:"Cust Id", key:"cust_id"},
  {label:"Name", key:"name"},
  {label:"Trip Id", key:"trip_id"},
  {label:"Mobile", key:"chat_mobile"},
  {label:"Destination", key:"destination"},
  {label:"Month", key:"month"},
]
const cheaders12=[
  {label:"Cust Id", key:"cust_id"},
  {label:"Name", key:"name"},
  {label:"Notes", key:"notes"},
  {label:"Demo", key:"demo"},
  {label:"Travel History", key:"th"},
]
    const closedsearch= async ()=>{
      
      try{
        if (searchData.start_date && searchData.end_date) {
            const data = await searchclosedTripsbyDate(
              searchData.start_date,
              searchData.end_date
            );

            const data2 = await searchDABTripsbyDate(
              searchData.start_date,
              searchData.end_date
            );
            // const data = await fetchActiveTrips();
            setlistclosedtripData([...data.data,...data2.data]);
           console.log(data2.data)
          } else {
            alert(
              "Please enter all parameters -start date and end date before search"
            );
          }
        }catch(err){
          console.log(err)
        }
    }

    const getclosedTrips=async()=>{
      try{
        if (searchData.start_date && searchData.end_date) {
          setworking(true)
            const data = await searchclosedTripsbyDate(
              searchData.start_date,
              searchData.end_date
            );
            const data2 = await searchconvTripsbyDate(
              searchData.start_date,
              searchData.end_date
            );
            setconvtripData(data2.data);
            setclosedtripData(data.data);
            //console.log(data2.data)
           //console.log(data.data)
           setworking(false)
          } else {
            alert(
              "Please enter all parameters -start date and end date before search"
            );
          }
        }catch(err){
          console.log(err)
        }
    }

    const getDest = async () => {
      try{
      // console.log(destinationlist)
      // const temp=destinationlist.filter(d=>"order" in d)
      setdest(destinationlist);
    }catch(err){
      console.log(err)
    }
    }

    const getEmployees = async () => {
      try{
      
      //const custdatalistfromdb= data.data
      // setemplist(data.data)
      const empsplist = employeelist.filter((emp) =>  emp.role=="Sales");
      const empshortname = empsplist.map((emp) => emp.short_name);
      setemp(empshortname)
      const empsplist2 = employeelist.filter((emp) =>  emp.role=="Operations" || role=="Operations-TL");
      const empshortname2 = empsplist2.map((emp) => emp.short_name);
      setempops(empshortname2)
    }catch(err){
      console.log(err)
    }
    };

    useEffect(() => {
      if(!loading){
      getEmployees()
      getDest();
      getsuppliers()
      }
    }, [cuser, role]);

    const convsearch= async ()=>{
      try{
      if (searchData6.start_date && searchData6.end_date ) {
          const data = await fetchconvcustdata(
            searchData6.start_date,
            searchData6.end_date
          );
          setlistcustData2(data.data);
         //console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
  }

   const convsearch2= async ()=>{
      try{
        
      if (searchData18.start_date && searchData18.end_date ) {
          const data = await fetchmarketingcustlist3(
            searchData18.start_date,
            searchData18.end_date
          );
          setlistcustData3(data.data);
          console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
  }

  const convsearch3= async ()=>{
      try{
        
      if (searchData28.start_date && searchData28.end_date ) {
          const data = await fetchmarketingcustlist4(
            searchData28.start_date,
            searchData28.end_date
          );
          setlistcustData4(data.data);
          console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
  }

  const acceptedsearch=async()=>{
       try{
      if (searchData19.start_date && searchData19.end_date ) {
          const data = await fetchacceptedtripsbydate(
            searchData19.start_date,
            searchData19.end_date
          );
           
          setacceptedtrips(data.data)
         //console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
   
  }

    const cancsearch= async ()=>{
      try{
        if (searchData2.start_date && searchData2.end_date) {
            const data = await searchallTripsbyDate(
              searchData2.start_date,
              searchData2.end_date
            );
            console.log(data.data);
            let temparr=[]
            for(let i=0;i<data.data.length;i++){
              const data2=await fetchTripsbyNumber(data.data[i].primary_mobile_number);
              const custData=await fetchCustomerbyNumber(data.data[i].primary_mobile_number)
              if(custData.data.length>0 && (!("marketing_message" in custData.data[0]) || custData.data[0].marketing_message==true)){
              if(Array.isArray(data2.data)){
              const data3=data2.data.filter(trip=> trip.trip_status=="Cancelled")
              if(data3.length==data2.data.length){
              const newdata={...data.data[i], primary_email_id:custData.data[0].primary_email_id}
                temparr.push(newdata)
              }
            }else{
              //console.log(data2.data)
              if(data2.data.trip_status=="Cancelled"){
                const newdata={...data.data[i], primary_email_id:custData.data[0].primary_email_id}
                temparr.push(newdata)
              }
            }
          }
            }
            setlistcanctripData(temparr);
            console.log(temparr)
          } else {
            alert(
              "Please enter all parameters -start date and end date before search"
            );
          }
        }catch(err){
          console.log(err)
        }

        // const data=await fetchActiveTripsbyTripOwner("Varun Dev")
        // setlistcanctripData(data.data)
    }

    const cancsearch2=async()=>{
      try{
        const data=await fetchCustomerbyDate(searchData2.start_date,searchData2.end_date)
        const data2=data.data.filter(cust=>cust.marketing_message !==false)
        let finarr=[]
        for(let i=0;i<data2.length;i++){
          let flag=0
          for(let j=0;j<data2[i].cust_trips.length;j++){
            if(data2[i].cust_trips[j].status=="Active"){
              flag=1
            }
          }
          if(!flag){
            finarr=[...finarr, data2[i]]
          }
        }
        setlistcanctripData(finarr);
      }catch(err){
        console.log(err)
      }
    }

    const leadsearch= async ()=>{
      try{
      if (searchData3.start_date && searchData3.end_date) {
          const data = await searchLeadsbyDate(
            searchData3.start_date,
            searchData3.end_date
          );
          var temp=data.data.filter(lead=>lead.lead_platform=="Manual")
          var temp2=data.data.filter(lead=> (lead.lead_platform=="Meta" && lead.lead_campaign=="Meta Chat") || (lead.lead_platform=="Meta" && lead.lead_campaign=="Call on Website WA"))
          var temp3=data.data.filter(lead=> (lead.lead_platform=="Organic" && lead.lead_campaign=="Website WA") || (lead.lead_platform=="Organic" && lead.lead_campaign=="Call") || (lead.lead_platform=="Organic" && lead.lead_campaign=="Call on Website WA"))
          setlistleadData([...temp2,...temp,...temp3]);
         
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
  }

  const tripsearchbystartdate= async ()=>{
   try{
      if ((searchData4.start_date && searchData4.end_date) || (searchData12.start_date && searchData12.end_date)) {
          const data = await searchconvTripsbyStartDate(
            searchData4.start_date,
            searchData4.end_date
          );
          setlistconvtripData(data.data);
         
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
  }    

  const tripsearchbystartdate2= async ()=>{
    try{
      //console.log(searchData4.start_date, searchData4.end_date)
       //console.log(searchData12.start_date, searchData12.end_date)
       if ((searchData4.start_date && searchData4.end_date) || (searchData12.start_date && searchData12.end_date)) {
           const data = await searchconvTripsbyStartDate(
             new Date(searchData12.start_date),
             new Date(searchData12.end_date)
           );
           //console.log(data.data)
           var temp=data.data.filter(tripdata=>tripdata.on_hold!==true && "booking" in tripdata && "transfer_state" in tripdata.booking && (tripdata.booking.transfer_state=="Requested" ||  tripdata.booking.transfer_state=="Accepted") && tripdata.hold_ops!==true)
           setlistconvtripData(temp);
          //console.log(temp)
         } else {
           alert(
             "Please enter all parameters -start date and end date before search"
           );
         }
       }catch(err){
         console.log(err)
       }
   } 

   const tripsearchbystartdate3= async ()=>{
    try{
      //console.log(searchData4.start_date, searchData4.end_date)
       //console.log(searchData12.start_date, searchData12.end_date)
       if ((searchData17.start_date && searchData17.end_date)) {
           const data = await fetchreviewhotel(
             new Date(searchData17.start_date),
             new Date(searchData17.end_date)
           );
           //console.log(data.data)
           
           setlistreviewtripData(data.data);
          //console.log(temp)
         } else {
           alert(
             "Please enter all parameters -start date and end date before search"
           );
         }
       }catch(err){
         console.log(err)
       }
   }
  
  const botripsearch= async ()=>{
    try{
       if (searchData7.start_date && searchData7.end_date) {
           const data = await searchboTripsbyDate(
             searchData7.start_date,
             searchData7.end_date
           );
           setlistbotripData(data.data);
          console.log(data.data)
         } else {
           alert(
             "Please enter all parameters -start date and end date before search"
           );
         }
       }catch(err){
         console.log(err)
       }
   } 

   const canctripsearch= async ()=>{
    try{
       if (searchData16.start_date && searchData16.end_date) {
           const data = await searchcancelledTripsbyDate(
             searchData16.start_date,
             searchData16.end_date
           );
           setlistcanctripData2(data.data);
          console.log(data.data)
         } else {
           alert(
             "Please enter all parameters -start date and end date before search"
           );
         }
       }catch(err){
         console.log(err)
       }
   }
  
  const activesearch=async()=>{
    try{
      //const data = await fetchTripsbyStatus("Active")
      //const data2 = await fetchTripsbyStatus("Hot")
      const data3=await fetchpotentialdata()
      console.log(data3.data.length)
      let finarr=[]
      for(let i=0; i<data3.data.length; i++){
        console.log(i)
        let max=0
        var temp={}
        if(data3.data[i].quote.length>0){
          //console.log(data3.data[i].trip_id)
       for (let j=0; j<data3.data[i].quote.length; j++){
        //console.log(data3.data[i].quote[j], max)
        const quoteData=await fetchQuotebyId(data3.data[i].quote[j])
        //console.log(quoteData)
          if(new Date(quoteData.data.updatedAt).getTime()>max){
            //console.log(data3.data[i].trip_id, data3.data[i].quote[j])
            max=new Date(quoteData.data.updatedAt).getTime()
            temp={...data3.data[i], finalquote:data3.data[i].quote[j],sp:"quote_price" in quoteData.data && "landprice" in quoteData.data.quote_price?quoteData.data.quote_price.landprice:0, cp:"cost_price" in quoteData.data && "landprice" in quoteData.data.cost_price?quoteData.data.cost_price.landprice:0}
          }
       }
       finarr=[...finarr, temp]
      }else{
        finarr=[...finarr, data3.data[i]]
      }
      }
      console.log(finarr)
      setlistactivetripData(finarr)

    }catch(err){
      console.log(err)
    }
  }

  const getleaddest=(leadid)=>{
    var temp=listleadData2.filter(l=>l.lead_id==leadid)
    if(temp.length>0){
      return temp[0].lead_destination
    }else{
      return ""
    }

  }

  const createdsearch=async()=>{
    try{
      let x=prompt("Press 1 for Hot, 2 for created, 3 for converted, 4 for start date")
      if (searchData11.start_date && searchData11.end_date) {
        if(x==2){
          const data = await searchTripsbyDate2(
            searchData11.start_date,
            searchData11.end_date
          );
          
          setlistcreatedtripData(data.data);
         console.log(data.data)
         var sd=DateCalc2(new Date(searchData11.start_date), -3)
         const ldata=await searchLeadsbyDate3(sd, searchData11.end_date)
         console.log(ldata.data)
         setlistleadData2(ldata.data)
        }else if(x==1){
          const data = await searchhotTripsbyDate(
            searchData11.start_date,
            searchData11.end_date
          );
          const temp=removeDuplicates(data.data, "trip_id")
          setlistcreatedtripData(temp);
         console.log(data.data)
        }else if(x==4){
          const data = await searchConvTripsbyStartDate(
            searchData11.start_date,
            searchData11.end_date
          );
          const temp=removeDuplicates(data.data, "trip_id")
          setlistcreatedtripData(temp);
         console.log(data.data)
        }else{
          const data = await searchconvTripsbyDate(
            searchData11.start_date,
            searchData11.end_date
          );
          const temp=removeDuplicates(data.data, "trip_id")
          setlistcreatedtripData(temp);
         console.log(data.data)
        }
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
  }

  const gridcellclicklead = (id) => {
    window.open("/lead/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  };

  const gridcellclick=(id)=>{
    window.open("/tripdataentry/" + id, '_blank');
    //console.log("/custdataentry/"+id);
  }

  const gridcellclickcust=(id)=>{
    window.open("/custdataentry/" + id, '_blank');
    //console.log("/custdataentry/"+id);
  }

  const custbybirthdate=async()=>{
    try{
    const data=await fetchcustbydob(searchData5.month)
    const tempobj=[]
      for(let i=0; i<data.data.length; i++){
        if(getmonthtext(data.data[i].cust_dob)==searchData5.month){
          tempobj.push(data.data[i])
        }
      }
    setlistcustData(tempobj)
  }catch(err){
    console.log(err)
  }
  }

  const custsearch=async()=>{
  try{
      const data=await fetchmarketingcustlist(searchData8.start_date, searchData8.end_date)
      setmarketingcustlist(data.data)
  }catch(err){
  console.log(err)
  }
  }

  const custsearch2=async()=>{
    try{
        const data=await fetchmarketingcustlist2(searchData9.start_date, searchData9.end_date)
        const temp=removeObjectsWithSameKeyValue(data.data, "cust_name")
        setmarketingcustlist2(temp)
        //console.log(data.data)
        console.log(temp)
    }catch(err){
    console.log(err)
    }
    }

  const custsearch3=async()=>{
    try{
        const data=await searchcancelledTripsbyDate(searchData10.start_date, searchData10.end_date)
        console.log(data.data)
      
        setmarketingcustlist3(data.data)
       
    }catch(err){
    console.log(err)
    }
    }

  const changemonth=(value)=>{
    var x=getmonth(value)
    //console.log(x)
    setsearchData({...searchData, start_date:new Date(x.startdate), end_date:new Date(x.enddate), month:value})
  }

  const sendwhatsappcampign=async()=>{
    let campaign=prompt("Enter campaign id:")
    let name=prompt("Enter campaign name:")
    let link=prompt("Enter image link:")
    if(campaign && name){
      if(link){
    const finallist = analyticsdatalistdisplay10.map((custdata) => ({
      name:custdata.name,
      number:custdata.chat_mobile,
      destination:custdata.destination,
      month:custdata.month,
      campaign:campaign,
      campaign_name:name,
      campaign_image_link:link,
    }));

    console.log(finallist)
    const temp=[
      {
        name:"ABC",
        destination:"Bali",
        month:"July 2024",
        number:"918882662454"
      },
      {
        name:"DEF",
        destination:"Kerala",
        month:"May 2024",
        number:"918882579621"
      },
      {
        name:"GHI",
        destination:"Kashmir",
        month:"June 2024",
        number:"919560348306"
      }
    ]


    for(let i=0; i<finallist.length; i++) {

    setTimeout(async function() {
      // Your code to be executed in each iteration goes here
      console.log('Iteration', i + 1);
      const data2=await ggwacampaign(finallist[i])
      console.log(data2)
  }, i * 5000);
    // setTimeout(timeout, 10000, finallist[i]);
    }
    }else{
      const finallist = analyticsdatalistdisplay10.map((custdata) => ({
        name:custdata.name,
        number:custdata.chat_mobile,
        destination:custdata.destination,
        month:custdata.month,
        campaign:campaign,
        campaign_name:name,
      }));
  
      console.log(finallist)
      for(let i=0; i<finallist.length; i++) {

    
     

        setTimeout(async function() {
          // Your code to be executed in each iteration goes here
          console.log('Iteration', i + 1);
          const data2=await ggwacampaign3(finallist[i])
          console.log(data2)
      }, i * 1000);
        // setTimeout(timeout, 10000, finallist[i]);
        }
    }
    
  }else{
    alert("Enter campaign id, name and link correctly and try again!")
  }
   
  }

   const sendwhatsappcampigncanc=async()=>{
    
 
    const finallist = analyticsdatalistdisplay16.map((custdata) => ({
      name:custdata.name,
      number:custdata.chat_mobile,
      destination:custdata.destination,
      month:custdata.month,
      campaign:"5257",
      campaign_name:"recent_cancelled_leads",
     
    }));

    console.log(finallist)
    const temp=[
      {
        name:"ABC",
        destination:"Bali",
        month:"July 2024",
        number:"918637004075",
        campaign:"5257",
        campaign_name:"recent_cancelled_leads",
      },
      {
        name:"DEF",
        destination:"Kerala",
        month:"May 2024",
        number:"918420772771",
        campaign:"5257",
        campaign_name:"recent_cancelled_leads",
      },
    
    ]


    for(let i=0; i<finallist.length; i++) {

    setTimeout(async function() {
      // Your code to be executed in each iteration goes here
      console.log('Iteration', i + 1);
      const data2=await ggwacampaign4(finallist[i])
      console.log(data2)
  }, i * 5000);
    // setTimeout(timeout, 10000, finallist[i]);
    }
   
    
 
   
  }

  const timeout = async(data) => {
    const data2=await ggwacampaign(data)
    console.log(data2.data)
    // Timeout Logic
  };

  const getdatemonthyear=(date)=>{
    var nd=DateCalc(7)
    let d=new Date(nd).getDate()
    let m=getmonthtext(nd)
    let y=new Date(nd).getFullYear()
    
    return d+" "+m+" "+y
  }

  const getmonthyear=(date)=>{
    
    let m=getmonthtext(date)
    let y=new Date(date).getFullYear()
    
    return m+" - "+y
  }

  const tripsearchbycanceldate=async()=>{
    try{
        const data=await searchcancelledTripsbyDate(searchData14.start_date, searchData14.end_date)
        console.log(data.data)
        setlistcanceltripData(data.data)
    }catch(err){
    console.log(err)
    }
    }

    const tripsearchbyairport=async()=>{
      try{
          const data=await fetchtripsbyairport(searchData15.lead_source_airport)
          console.log(data.data)
          setlisttripairportData(data.data)
      }catch(err){
      console.log(err)
      }
      }

  var reviewnumber=[], internalreviewnumber=[], fivestarreviewnumber=[]
  var ptnps=0, psnps=0
  var pstemp=[], pstemp2=[], pttemp=[], pttemp2=[], pstotal=[], pttotal=[], rnt=[], rng=[], rnt2=[]
  var l1=[...convtripData], l2=[...closedtripData]
  if(closedtripData.length>0){
    if(searchData.destination && searchData.destination !==""){
      l1=convtripData.filter(trip=>trip.primary_destination==searchData.destination)
      l2=closedtripData.filter(trip=>trip.primary_destination==searchData.destination)
    }
    if(searchData.owner){
      l1=l1.filter(trip=>"booking" in trip && "ops_assigned" in trip.booking && trip.booking.ops_assigned==searchData.owner)
      l2=l2.filter(trip=>"booking" in trip && "ops_assigned" in trip.booking && trip.booking.ops_assigned==searchData.owner)
    }
    reviewnumber=l2.filter(trip=>trip.trip_review_score)
    fivestarreviewnumber=reviewnumber.filter(trip=>trip.trip_review_score==5)
    pstotal=l1.filter(trip=>trip.post_sales_score)
    pstemp=l1.filter(trip=>trip.post_sales_score && trip.post_sales_score >8)
    pstemp2=l1.filter(trip=>trip.post_sales_score && trip.post_sales_score <7)
    psnps=((pstemp.length-pstemp2.length)/pstotal.length*100).toFixed(1)
    internalreviewnumber=l2.filter(trip=>trip.post_trip_score)
    rnt=l2.filter(trip=>"review_attempts" in trip && trip.review_attempts==0)
    rnt2=l2.filter(trip=>"review_attempts" in trip && trip.review_attempts==-1)
    rng=l2.filter(trip=>"review_attempts" in trip && trip.review_attempts==3 && !("post_trip_score" in trip && trip.post_trip_score>=0))
    pttemp=l2.filter(trip=>trip.post_trip_score && trip.post_trip_score >8)
    pttemp2=l2.filter(trip=>trip.post_trip_score && trip.post_trip_score <7)
    ptnps=((pttemp.length-pttemp2.length)/internalreviewnumber.length*100).toFixed(1)
  }

  var l1=listleadData
  if(searchData3.canc=="Yes"){
    l1=listleadData.filter(lead=>lead.cust_create==false)
  }else if(searchData3.canc=="No"){
    l1=listleadData.filter(lead=>lead.cust_create==true)}

  var lc=removeDuplicates(listclosedtripData, "trip_id")

   const upselltotal = (upsellData) => {
    let sum = 0;
    if (upsellData.length == 0) {
      return sum;
    } else {
      if(searchData5.inventory){
        upsellData.map((item) =>
          item.inventory=="Hotel Upsell Ops"?sum:
      (item.inventory==searchData5.inventory
       
          ? (sum = sum + parseInt(item.sp))
          
        : sum)
    );
      }else{
      upsellData.map((item) =>
        item.inventory=="Hotel Upsell Ops"?sum:
          (sum = sum + parseInt(item.sp))
      );
    }
      return sum;
    }
  };

  // const upsellprofittotal = (upsellData) => {
  //   let sum = 0;
  //   if (upsellData.length == 0) {
  //     return sum;
  //   } else {
   
      
  //     upsellData.map((item) =>
       
  //          (sum = sum + parseInt(item.sp)-parseInt(item.cp))
  //     );
    
  //     return sum;
  //   }
  // };
  var l200=[...listconvtripData]
  
  if(searchData4.future_trips){
    if(searchData4.future_trips=="Without JC"){
    l200=l200.filter(tripdata => tripdata.on_hold!==true && "booking" in tripdata && "transfer_state" in tripdata.booking && (tripdata.booking.transfer_state=="Requested" ||  tripdata.booking.transfer_state=="Accepted") && tripdata.hold_ops!==true)
  }else{
  l200=l200.filter(tripdata => tripdata.on_hold!==true && "booking" in tripdata && "transfer_state" in tripdata.booking && (tripdata.booking.transfer_state=="Requested" ||  tripdata.booking.transfer_state=="Accepted" ||  tripdata.booking.transfer_state=="Just Converted") && tripdata.hold_ops!==true)
  }
  }

   var l101=[...listcanceltripData]
      var l201=[...listcanctripData2]
      if(leadfilterData.trip_owner){
        l101=l101.filter(t=>t.trip_owner==leadfilterData.trip_owner)
        l201=l201.filter(t=>t.trip_owner==leadfilterData.trip_owner)
      }

    const analyticsdatalistdisplay = lc.map((tripdata) => ({
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: listclosedtripData.indexOf(tripdata),
        destination:tripdata.primary_destination,
        start_date:tripdata.trip_start_date,
        trip_id:tripdata.trip_id,
        mobile_number:tripdata.primary_mobile_number,
        ops_owner:"booking" in tripdata && "ops_assigned" in tripdata.booking?tripdata.booking.ops_assigned:"",
        status:tripdata.trip_status,
        first_payment:"cust_payments" in tripdata && tripdata.cust_payments.length>0?tripdata.cust_payments[0].date :"",
        revenue:"cust_payments" in tripdata?total(tripdata.cust_payments):0,
        review:tripdata.trip_review_score,
        createdAt:tripdata.createdAt,
        tl:tripdata.team_leader,
        upsell_value: "upsell" in tripdata && tripdata.upsell.length>0?upselltotal(tripdata.upsell):0,
        upsell_profit: "upsell" in tripdata && tripdata.upsell.length>0?upsellprofittotal(tripdata.upsell):0,
        pax:Number(tripdata.number_adults)+("number_child" in tripdata?Number(tripdata.number_child):0),
        email:"primary_email_id" in tripdata?tripdata.primary_email_id:("customer_details" in tripdata && tripdata.customer_details.length>0?tripdata.customer_details[0].primary_email_id:""),
        time_to_convert:"cust_payments" in tripdata && tripdata.cust_payments.length>0?((new Date(tripdata.createdAt).getTime()-new Date(tripdata.cust_payments[0].date).getTime())/(1000*60*60*24)).toFixed(1):""
      }));
    
      const analyticsdatalistdisplay2 = listcanctripData.map((tripdata) => ({
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: listcanctripData.indexOf(tripdata),
        destination:tripdata.primary_destination,
        start_date:tripdata.trip_start_date,
        trip_id:tripdata.trip_id,
        email: tripdata.primary_email_id,
        mobile_number:tripdata.primary_mobile_number,
        status:tripdata.trip_status,
        quality:(("lead") in tripdata)?getquality(tripdata.lead.lead_status, tripdata.lead.time_to_book, tripdata.lead.lead_platform, tripdata.trip_start_date, tripdata.lead.quality_upgrade, null):getquality(null, null, tripdata.trip_channel, tripdata.trip_start_date,null, null),
      }));

      const analyticsdatalistdisplay3 = l1.map((leaddata) => ({
        owner: leaddata.lead_owner,
        name:leaddata.lead_name,
        id: listleadData.indexOf(leaddata),
        destination:leaddata.lead_destination,
        start_date:leaddata.lead_travel_date,
        work_complete_date:leaddata.work_complete_date?leaddata.work_complete_date:"",
        lead_id:leaddata.lead_id,
        campaign:leaddata.lead_campaign,
        platform:leaddata.lead_platform,
        createdAt_date:leaddata.createdAt,
        createdAt_time:leaddata.createdAt?.split("T").slice(1,2),
        lead_canc:leaddata.cust_create?"No":"Yes",
        lead_canc_reason:leaddata.canc_reason_notes,

      }));
      const analyticsdatalistdisplay4 = l200.map((tripdata) => ({
        owner: tripdata.trip_owner,
        name:getstate(tripdata)+tripdata.cust_name,
        id: l200.indexOf(tripdata),
        destination:tripdata.primary_destination,
        start_date:tripdata.trip_start_date,
        email:tripdata.primary_email_id,
        conv_date:getconvdate(tripdata),
        trip_id:tripdata.trip_id,
        mobile_number:tripdata.primary_mobile_number,
        status:tripdata.trip_status,
        ops_owner:"booking" in tripdata?tripdata.booking.ops_assigned:"",
        channel:tripdata.trip_channel,
        pax: "number_child" in tripdata?Number(tripdata.number_adults)+Number(tripdata.number_child):Number(tripdata.number_adults),
        profit:getprofit(tripdata),
        total:total(tripdata.cust_payments),
        pending:pending(tripdata.cust_payments),
        flight_sp:tripdata.flight_sp+tripdata.visa_sp+tripdata.anc_sp+tripdata.extra_sp,
        pd:tripdata.no_tcs,
        sc:tripdata.no_tax,
        of:tripdata.only_flight,
      }));

      const analyticsdatalistdisplay5 = listcustData.map((custdata) => ({
        
        name:custdata.cust_name,
        id: listcustData.indexOf(custdata),
        dob:custdata.cust_dob,
        cust_id:custdata.cust_id,
        cust_city:custdata.cust_city,
        chat_mobile:custdata.chat_mobile_number,
        cust_anniversary:custdata.cust_anniversary,
        email:custdata.primary_email_id,
      }));

      const analyticsdatalistdisplay6 = listcustData2.map((custdata) => ({
        
        name:custdata.cust_name,
        id: listcustData2.indexOf(custdata),
        dob:custdata.cust_dob,
        cust_id:custdata.cust_id,
        cust_city:custdata.cust_city,
        chat_mobile:custdata.chat_mobile_number,
        cust_anniversary:custdata.cust_anniversary,
        email:custdata.primary_email_id,
      }));

      const analyticsdatalistdisplay7 = listbotripData.map((tripdata) => ({
        
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: listbotripData.indexOf(tripdata),
        destination:tripdata.primary_destination,
        source: tripdata.trip_channel,
        previous_status:"status_history" in tripdata && tripdata.status_history.length>1?tripdata.status_history[tripdata.status_history.length-1].new_status:"",
        start_date:tripdata.trip_start_date,
        trip_id:tripdata.trip_id,
        mobile_number:tripdata.primary_mobile_number,
        canc_reason:tripdata.trip_canc_reason,
        canc_reason_short:tripdata.trip_canc_reason_short,
      }));

      const analyticsdatalistdisplay8 = listactivetripData.map((tripdata) => ({
        
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: listactivetripData.indexOf(tripdata),
        destination:tripdata.primary_destination,
        start_date:tripdata.trip_start_date,
        trip_id:tripdata.trip_id,
        chat_mobile:tripdata.primary_mobile_number,
        adult:tripdata.number_adults,
        child:tripdata.number_child,
        status:tripdata.trip_status,
        quality:(("lead") in tripdata)?getquality(tripdata.lead.lead_status, tripdata.lead.time_to_book, tripdata.trip_channel, tripdata.trip_start_date,tripdata.lead.quality_upgrade, null):getquality(null, null, tripdata.trip_channel, tripdata.trip_start_date,null, null),
        email:tripdata.primary_email_id,
        prev_note: "follow_up"  in tripdata && tripdata.follow_up.length>1
        ? tripdata.follow_up[tripdata.follow_up.length - 2].notes
        : "",
      current_note: "follow_up"  in tripdata && tripdata.follow_up.length>0
        ? tripdata.follow_up[tripdata.follow_up.length - 1].notes
        : "",
        sp:tripdata.sp,
        cp:tripdata.cp,
        profit:tripdata.sp-tripdata.cp,
        profit_perc: Math.round(((tripdata.sp-tripdata.cp)/tripdata.sp) * 100),
        quote_id:tripdata.finalquote,
        channel:tripdata.trip_channel,
      }));

      const analyticsdatalistdisplay9 = marketingcustlist.map((custdata) => ({
        
        cust_id: custdata.cust_id,
        name:custdata.cust_name,
        id: marketingcustlist.indexOf(custdata),
        cust_city:custdata.cust_city,
        cust_state:custdata.cust_state,
        //trip_id:custdata.trip_id,
        chat_mobile:custdata.chat_mobile_number,
        cust_mm:"marketing_message" in custdata?custdata.marketing_message:"",
        email:custdata.primary_email_id,
        
      }));

   const analyticsdatalistdisplay17 = l201.map((tripdata) => ({
        
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: l201.indexOf(tripdata),
        destination:tripdata.primary_destination,
        source: tripdata.trip_channel,
        start_date:tripdata.trip_start_date,
        trip_id:tripdata.trip_id,
        mobile_number:tripdata.primary_mobile_number,
        canc_reason:tripdata.trip_canc_reason,
        canc_reason_short:tripdata.trip_canc_reason_short,
      }));

      const analyticsdatalistdisplay10 = marketingcustlist2.map((custdata) => ({
        
        cust_id: custdata.cust_id,
        name:custdata.cust_name,
        id: marketingcustlist2.indexOf(custdata),
        chat_mobile:"91"+custdata.chat_mobile_number,
        trip_id:"trip_details" in custdata && custdata.trip_details.length>0 && "trip_id" in custdata.trip_details[0]?custdata.trip_details[0].trip_id:"",
        destination:custdata.trip_details[0].primary_destination,
        month:getmonthyear(custdata.trip_details[0].createdAt),
      }));

      const analyticsdatalistdisplay100 = listcustData4.map((data) => ({
         id: listcustData4.indexOf(data),
        dest: data.primary_destination,
        name:data.cust_name,
        email:data.primary_email_id,
        number:"91"+(data.primary_mobile_number).toString(),
        // destination:custdata.trip_details[0].primary_destination,
        // trip_start_date:custdata.trip_details[0].trip_start_date,
      }));



       const analyticsdatalistdisplay16 = marketingcustlist3.map((data) => ({
        
        cust_id: data.cust_id,
        name:data.cust_name,
        id: marketingcustlist3.indexOf(data),
        chat_mobile:"91"+data.primary_mobile_number,
        trip_id:data.trip_id,
        destination:data.primary_destination,
        month:getdatemonthyear(data.createdAt),
      }));

      const analyticsdatalistdisplay11 = listcreatedtripData.map((data) => ({
        
        trip_id: data.trip_id,
        name:data.cust_name,
        id: listcreatedtripData.indexOf(data),
        owner:data.trip_owner,
        tl:data.team_leader,
        destination:data.primary_destination,
        quote:"quote" in data?data.quote.join(", "):"",
        createdAt:data.createdAt,
        convAt:"trip_id" in data && (data.trip_status=="Converted" || data.trip_status=="Closed" || data.trip_status=="Dropped After Booking")?getconvdate(data):"",
        cancAt:data.canc_flag_time,
        hotAt:"trip_id" in data?gethotdate(data):"",
        status:data.trip_status,
        trip_start_date:data.trip_start_date,
        time_to_convert:"trip_id" in data && (data.trip_status=="Converted" || data.trip_status=="Closed" || data.trip_status=="Dropped After Booking")?Math.round((new Date(getconvdate(data)).getTime()-new Date(gethotdate(data)).getTime())/(1000*60*60)):"",
        time_to_hot:"trip_id" in data?Math.round((new Date(gethotdate(data)).getTime()-new Date(data.createdAt).getTime())/(1000*60*60)):"",
        voucher_matched_date:"booking" in data && data.booking.voucher_matched_date?data.booking.voucher_matched_date:"",
        accepted_date:data.accepted_date,
        land_booking_date:data.land_booking_date,
        hotel_booking_date:data.hotel_booking_date,
        trip_review_date:data.trip_review_date,
        time_to_accept:"trip_id" in data && (data.trip_status=="Converted" || data.trip_status=="Closed")?Math.round((new Date(data.accepted_date).getTime()-new Date(data.converted_date).getTime())/(1000*60*60)):"",
        time_to_book_hotel:"trip_id" in data && (data.trip_status=="Converted" || data.trip_status=="Closed")?Math.round((new Date(data.hotel_booking_date).getTime()-new Date(data.accepted_date).getTime())/(1000*60*60)):"",
        time_to_book_land:"trip_id" in data && (data.trip_status=="Converted" || data.trip_status=="Closed")?Math.round((new Date(data.land_booking_date).getTime()-new Date(data.accepted_date).getTime())/(1000*60*60)):"",
        time_to_vm:"trip_id" in data && (data.trip_status=="Converted" || data.trip_status=="Closed") && "booking" in data && "voucher_matched_date" in data.booking?Math.round((new Date(data.trip_start_date).getTime()-new Date(data.booking.voucher_matched_date).getTime())/(1000*60*60)):"",
        lead_destination:"lead" in data?getleaddest(data.lead.lead_id):"",
        trip_destination:data.primary_destination,
        lead_id:"lead" in data?data.lead.lead_id:"",
        booking_status:"booking" in data? data.booking.transfer_state:"",
        hold_ops:"hold_ops" in data? data.hold_ops:"",
      }));

      const getcr=(cr)=>{
        var temp=cr.filter(c=>(c.answered_agent_name=="Deepali" || c.answered_agent_name=="sumit" || c.answered_agent_name=="AbhijeetJ") && Number(c.outbound_sec)>0)
        return temp.length>0?true:false
      }

      const analyticsdatalistdisplay20 = acceptedtrips.map((tripdata) => ({
        accepted_date:tripdata.accepted_date,
        bc:"booking" in tripdata && "briefing_call" in tripdata.booking?tripdata.booking.briefing_call:"",
        hp:"booking" in tripdata && "hotel_pitch" in tripdata.booking?tripdata.booking.hotel_pitch:"",
        jc_date:tripdata.jc_date,
        ops_owner:"booking" in tripdata && "ops_assigned" in tripdata.booking?tripdata.booking.ops_assigned:"",
        name:tripdata.cust_name,
        id: acceptedtrips.indexOf(tripdata),
        destination:tripdata.primary_destination,
        trip_id:tripdata.trip_id,
        status:"booking" in tripdata && "transfer_state" in tripdata.booking?tripdata.booking.transfer_state:"",
        callrecord:"callrecord" in tripdata && tripdata.callrecord.length>0?getcr(tripdata.callrecord):"",
      }));

      const analyticsdatalistdisplay14 = l101.map((tripdata) => ({
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: l101.indexOf(tripdata),
        destination:tripdata.primary_destination,
        start_date:tripdata.trip_start_date,
        email:tripdata.primary_email_id,
        canc_date:"status_history" in tripdata?tripdata.status_history.date:"",
        trip_id:tripdata.trip_id,
        mobile_number:tripdata.primary_mobile_number,
        status:tripdata.trip_status,
        canc_reason_short:tripdata.trip_canc_reason_short,
        canc_reason:tripdata.trip_canc_reason,
        channel:tripdata.trip_channel,
        pax: "number_child" in tripdata?Number(tripdata.number_adults)+Number(tripdata.number_child):Number(tripdata.number_adults),
       
      }));

      const analyticsdatalistdisplay18 = listreviewtripData.map((tripdata) => ({
        pt_score:tripdata.post_trip_score,
        name:tripdata.cust_name,
        id: listreviewtripData.indexOf(tripdata),
        destination:tripdata.primary_destination,
        trip_id:tripdata.trip_id,
        hotel_name:tripdata.review_hotel_name,
        cust_comment:tripdata.review_comment,
      }));

      var l21=[...listconvtripData]
      if(reviewfilter){
        l21=l21.filter(trip=>trip[reviewfilter])
      }

      const getreviewattempts=(text)=>{
        if(text=="3"){
          return text+" (RNG)"
        }else if(text=="0"){
          return text+" (RNT)"
        }else if(text=="-1"){
          return text+" (RNT-G)"
        }else{
          return text
        }
      }

      const getsuppliers = async () => {
          try{
          //console.log(tripData.primary_destination)
          //const data = await fetchSuppliersbyDest(tripData.primary_destination);
          const data = await fetchSuppliers();
        
          let sortedSuppliers = data.data.sort((a, b) => {
            if (a.supplier_name < b.supplier_name) {
                return -1;
            }
            if (a.supplier_name > b.supplier_name) {
                return 1;
            }
            return 0;
        });;
              setsData(sortedSuppliers)
            }catch(err){
              console.log(err)
            }
        };

       const getsuppliertype=(name)=>{
    const type=sData.filter(sup => sup.supplier_name==name)
    //console.log(type)
     return type.length>0?type[0].supplier_type:""
  }

      const getsuppliernames=(trip)=>{
        if("supplier_payments" in trip){
          var text=""
          for(let i=0;i<trip.supplier_payments.length;i++){
            if(getsuppliertype(trip.supplier_payments[i].name)=="DMC" && !text.includes(trip.supplier_payments[i].name)){
              text=text+trip.supplier_payments[i].name+" - "
            }
          }
          return text
        }else{
          return ""
        }
      }

      const analyticsdatalistdisplay12 = l21.map((tripdata) => ({
        trip_id: tripdata.trip_id,
        trip_owner: tripdata.trip_owner,
        name:getstate(tripdata)+tripdata.cust_name,
        id: l21.indexOf(tripdata),
        attempt:tripdata.review_attempts,
        fup:"follow_up" in tripdata && tripdata.follow_up.length>1 && tripdata.follow_up[tripdata.follow_up.length-1].fupautonote=="Call later for feedback"?tripdata.follow_up[tripdata.follow_up.length-1].date:"",
        destination:tripdata.primary_destination,
        supplier:getsuppliernames(tripdata),
        supplier_issue: tripdata.review_land_issue || tripdata.review_supplier_issue?1:"",
       analysis:tripdata.review_analysis,
       pt_score:tripdata.post_trip_score,
       cust_comment:tripdata.review_comment,
       trip_end_date: "duration" in tripdata && "trip_start_date" in tripdata?DateCalc2(tripdata.trip_start_date, tripdata.duration):"",
      }));

      const analyticsdatalistdisplay15 = listtripairportData.map((tripdata) => ({
        owner: tripdata.trip_owner,
        name:tripdata.cust_name,
        id: listtripairportData.indexOf(tripdata),
        destination:tripdata.primary_destination,
        start_date:tripdata.trip_start_date,
        trip_id:tripdata.trip_id,
        mobile_number:tripdata.primary_mobile_number,
        conv_date:"trip_id" in tripdata && (tripdata.trip_status=="Converted" || tripdata.trip_status=="Closed" || tripdata.trip_status=="Dropped After Booking")?getconvdate(tripdata):"",
        pt_score:tripdata.post_trip_score,
      }));

      const analyticsdatalistdisplay19 = listcustData3.map((tripdata) => ({
        demo: "cust_details" in tripdata && tripdata.cust_details.length>0?tripdata.cust_details[0].cust_demo:"",
        th: "cust_details" in tripdata && tripdata.cust_details.length>0?tripdata.cust_details[0].cust_travel_history:"",
        notes: "cust_details" in tripdata && tripdata.cust_details.length>0?tripdata.cust_details[0].cust_notes:"",
        name:"cust_details" in tripdata && tripdata.cust_details.length>0?tripdata.cust_details[0].cust_name:"",
        cust_id:"cust_details" in tripdata && tripdata.cust_details.length>0?tripdata.cust_details[0].cust_id:"",
        id: listcustData3.indexOf(tripdata),
      }));

      const datalistdisplay=[{
        ps_nps:psnps?psnps:"",
        pt_nps:ptnps?ptnps:"",
        pt_prom:pttemp.length +" ("+Math.round(pttemp.length/internalreviewnumber.length*100)+"%)",
        pt_det: pttemp2.length +" ("+Math.round(pttemp2.length/internalreviewnumber.length*100)+"%)",
        pt_neutral:internalreviewnumber.length-pttemp.length-pttemp2.length +" ("+Math.round((internalreviewnumber.length-pttemp.length-pttemp2.length)/internalreviewnumber.length*100)+"%)",
        ps_prom:pstemp.length,
        ps_det: pstemp2.length,
        ps_neutral:pstotal.length-pstemp.length-pstemp2.length,
        internal_number_review:internalreviewnumber.length>0?(internalreviewnumber.length+" ("+Math.round(internalreviewnumber.length/closedtripData.length*100)+"%)"):"",
        number_review:reviewnumber.length>0?(reviewnumber.length+" ("+Math.round(reviewnumber.length/closedtripData.length*100)+"%)"):"",
        closed:l2.length,
        rnt_genuine:rnt2.length,
        rnt:rnt.length,
        rng:rng.length,
        pending:l2.length-rng.length-rnt.length-rnt2.length-internalreviewnumber.length,
        review_score: fivestarreviewnumber.length,
        review_score_perc: fivestarreviewnumber.length/pttemp.length,
        fair_nps:((pttemp.length-pttemp2.length-rnt.length-rnt2.length*0.9)/(l2.length+rnt.length+rnt2.length*0.9)*100).toFixed(1),
        id:1,
      }]
      //console.log(datalistdisplay)

      const gridcellkeydown=(name, description)=>{
        alert("Comment: " +description)
        
        
      }

      const getTripsbystartdate=async()=>{
        try{
          if (searchData.start_date && searchData.end_date) {
            setworking(true)
            //console.log(searchData.start_date, searchData.end_date)
              const data = await searchConvTripsbyStartDate(
                new Date(searchData.start_date),
                new Date(searchData.end_date)
              );
               //console.log(data.data)
              var temp=data.data.filter(tripdata=>tripdata.on_hold!==true && "booking" in tripdata && "transfer_state" in tripdata.booking && (tripdata.booking.transfer_state=="Requested" ||  tripdata.booking.transfer_state=="Accepted") && tripdata.hold_ops!==true)
              setclosedtripData(temp);
             
            // console.log(temp)
             setworking(false)
            } else {
              alert(
                "Please enter all parameters -start date and end date before search"
              );
            }
          }catch(err){
            console.log(err)
          }
      }

      
   //console.log(listclosedtripData)

    return ( <div>
      {/* {role=="Admin" || role=="Marketing"?(
            <Paper variant="outlined" className={classes.paper} elevation={10}>
            
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Manual Leads
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData3({
                      ...searchData3,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData3({ ...searchData3, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={leadsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="cancelled">Cancelled?</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="cancelled" value={searchData3.canc} onChange={(e)=> setsearchData3({...searchData3, canc: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                 <MenuItem value={"Yes"}>Yes</MenuItem>
                 <MenuItem value={"No"}>No</MenuItem>
                </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 1600, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns2}
                    autoPageSize
                    
                    onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            ):("")} */}
            {role=="Admin"?(
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Closed Trips (Total Upsell Value: {getSumByKey2(analyticsdatalistdisplay, "upsell_value")} || Total Upsell Profit: {getSumByKey2(analyticsdatalistdisplay, "upsell_profit")})
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Closed On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData({
                      ...searchData,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Closed On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData({ ...searchData, end_date: e.target.value })
                  }
                />
                {analyticsdatalistdisplay.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
                
                <Button
                  onClick={closedsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                    onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>):("")}
            {role=="Admin"?(
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                All Trips
              </Typography>
              <p> New Search loads, name, phone and email only for marketing purposes</p>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData2({
                      ...searchData2,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData2({ ...searchData2, end_date: e.target.value })
                  }
                />
                  {analyticsdatalistdisplay2.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={cancsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                <Button
                  onClick={cancsearch2}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  New Search
                </Button>
              </div>
              {analyticsdatalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay2}
                    columns={columns}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          ):("")}
        {role=="Admin"?(
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Conv Trips
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({
                      ...searchData4,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({ ...searchData4, end_date: e.target.value })
                  }
                />
                  {analyticsdatalistdisplay4.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay4} headers={headers3}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={tripsearchbystartdate}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                  <FormControl
                                style={{
                                  minWidth: 240,
                                  marginTop: 16,
                                  marginRight: 32,
                                  marginLeft: 8,
                                }}
                              >
                                <InputLabel id="CF">Confirmed Trips</InputLabel>
                                <Select
                                  classname={classes.textField}
                                  labelId="CF"
                                  value={searchData4.future_trips}
                                  onChange={(e) =>
                                    setsearchData4({ ...searchData4, future_trips: e.target.value })
                                  }
                                >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"Without JC"}>Without JC</MenuItem>
                                </Select>
                              </FormControl>
              </div>
              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                {working?(<Loading message={`Patience is virtue...`} />):(
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                )}
                  
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>   ):("")}
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Conv Trips by airport
              </Typography>
              <div align="center">
              <FormControl
                          style={{
                            minWidth: 480,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="sourceairport">Source Airport (Airport code only)</InputLabel>
                          <Select
                            classname={classes.textField}
                            displayEmpty
                            labelId="sourceairport"
                            value={searchData15.lead_source_airport}
                            onChange={(e)=> setsearchData15({ ...searchData15, lead_source_airport: e.target.value })}
                            inputProps={{className: classes.input, pattern:"[A-Z]{3}"}}
                            InputLabelProps={{ shrink: true }}
                          >
                            
                            <MenuItem value={"DNK"}>DNK</MenuItem>
                            {airportlist2.map(data=>
                                  <MenuItem value={data.airport}>{data.airport}</MenuItem>
                                )}
                          
                          </Select>
                        </FormControl>
                <Button
                  onClick={tripsearchbyairport}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay15.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                {working?(<Loading message={`Patience is virtue...`} />):(
                  <DataGrid
                    rows={analyticsdatalistdisplay15}
                    columns={columns15}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                )}
                  
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            {role=="Admin" || role=="Marketing" || cuser=="Vinit"?(
              <div>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Cancelled Trips
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Cancelled On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData14({
                      ...searchData14,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Cancelled On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData14({ ...searchData14, end_date: e.target.value })
                  }
                />
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                            <InputLabel id="trip owner">Trip Owner</InputLabel>
                                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={leadfilterData.trip_owner} onChange={(e)=> setleadfilterData({...leadfilterData, trip_owner: e.target.value})}>
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Amit"}>Amit</MenuItem>
                                {emp.map((emp) => {
                                return <MenuItem value={emp}>{emp}</MenuItem>;
                              })}
                              </Select>
                                </FormControl>
                
                  {analyticsdatalistdisplay14.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay14} headers={headers13}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={tripsearchbycanceldate}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay14.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay14}
                    columns={columns13}
                    autoPageSize
                    onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                BO Trips
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="BO Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData7({
                      ...searchData7,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="BO Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData7({ ...searchData7, end_date: e.target.value })
                  }
                />
                  {analyticsdatalistdisplay7.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay7} headers={headers4}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={botripsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay7.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay7}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Cancelled Trips 2
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Cancelled Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData16({
                      ...searchData16,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Cancelled Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData16({ ...searchData16, end_date: e.target.value })
                  }
                />
                 <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                            <InputLabel id="trip owner">Trip Owner</InputLabel>
                                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={leadfilterData.trip_owner} onChange={(e)=> setleadfilterData({...leadfilterData, trip_owner: e.target.value})}>
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Amit"}>Amit</MenuItem>
                                {emp.map((emp) => {
                                return <MenuItem value={emp}>{emp}</MenuItem>;
                              })}
                              </Select>
                                </FormControl>
                  {analyticsdatalistdisplay17.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay17} headers={headers4}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={canctripsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay17.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay17}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Customers DOB
              </Typography>
              <div align="center">
              <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="month">Birth Month</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="month" value={searchData5.month} onChange={(e)=> setsearchData5({...searchData5, month: e.target.value})}>
                <MenuItem value={"January"}>January</MenuItem>
                <MenuItem value={"February"}>February</MenuItem>
                <MenuItem value={"March"}>March</MenuItem>
                <MenuItem value={"April"}>April</MenuItem>
                <MenuItem value={"May"}>May</MenuItem>
                <MenuItem value={"June"}>June</MenuItem>
                <MenuItem value={"July"}>July</MenuItem>
                <MenuItem value={"August"}>August</MenuItem>
                <MenuItem value={"September"}>September</MenuItem>
                <MenuItem value={"October"}>October</MenuItem>
                <MenuItem value={"November"}>November</MenuItem>
                <MenuItem value={"December"}>December</MenuItem>
                </Select>
                </FormControl>

               
                  {analyticsdatalistdisplay5.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay5} headers={cheaders}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={custbybirthdate}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay5.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay5}
                    columns={ccolumns}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                    onCellDoubleClick={(getValue) =>
              gridcellclickcust(getValue.row.cust_id)}
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Converted Customer Details (Meta Ad)
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData6({
                      ...searchData6,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData6({ ...searchData6, end_date: e.target.value })
                  }
                />
                {analyticsdatalistdisplay6.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay6} headers={cheaders}>Download CSV</CSVLink>
                   </div>
                ):("")}
                
                <Button
                  onClick={convsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay6.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay6}
                    columns={ccolumns}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                    onCellDoubleClick={(getValue) =>
              gridcellclickcust(getValue.row.cust_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            </div>
            ):("")}
            {role=="Admin"?(
            <div>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Active Trips
              </Typography>
              <div align="center">
                
                {analyticsdatalistdisplay8.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay8} headers={headers5}>Download CSV</CSVLink>
                   </div>
                ):("")}
                
                <Button
                  onClick={activesearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>
              {analyticsdatalistdisplay8.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay8}
                    columns={columns5}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                    onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Trip Journey
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData11({
                      ...searchData11,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData11({ ...searchData11, end_date: e.target.value })
                  }
                />
                {analyticsdatalistdisplay11.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay11} headers={headers11}>Download CSV</CSVLink>
                   </div>
                ):("")}
                
                <Button
                  onClick={createdsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay11.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay11}
                    columns={columns11}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                    onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Customer list
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData8({
                      ...searchData8,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData8({ ...searchData8, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={custsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                 {analyticsdatalistdisplay9.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay9} headers={headers6}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay9.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay9}
                    columns={ccolumns2}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclickcust(getValue.row.cust_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
             
            </div>
            ):("")}
            {role=="Admin" || role=="Marketing" || cuser=="Tarun"?(
            <div>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Converted Customer Demo Details
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Converted On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData18({
                      ...searchData18,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Converted On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData18({ ...searchData18, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={convsearch2}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                 {analyticsdatalistdisplay19.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay19} headers={cheaders12}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay19.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay19}
                    columns={ccolumns12}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclickcust(getValue.row.cust_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Whatsapp Customer list
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData9({
                      ...searchData9,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Created On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData9({ ...searchData9, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={custsearch2}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                {cuser=="Debayan" || cuser=="JaiKaushik"?(
                  <Button
                  onClick={()=>sendwhatsappcampign()}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                >
                  Send
                </Button>
                ):("")}
                
                 {analyticsdatalistdisplay10.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay10} headers={cheaders2}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay10.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay10}
                    columns={ccolumns3}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclickcust(getValue.row.cust_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
             <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Cancelled Customer list
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Cancelled On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData10({
                      ...searchData10,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Cancelled On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData10({ ...searchData10, end_date: e.target.value })
                  }
                />
                <Button
                  onClick={custsearch3}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                {cuser=="Debayan" || cuser=="JaiKaushik"?(
                  <Button
                  onClick={()=>sendwhatsappcampigncanc()}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                >
                  Send
                </Button>
                ):("")}
                
                 {analyticsdatalistdisplay16.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay16} headers={cheaders2}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay16.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay16}
                    columns={ccolumns4}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
             <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Remarketing
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Start On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData28({
                      ...searchData28,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Start On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData28({ ...searchData28, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={convsearch3}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                 {analyticsdatalistdisplay100.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay100} headers={headers15}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay100.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay100}
                    columns={ccolumns15}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclickcust(getValue.row.cust_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            </div>):("")}
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Accepted Trips
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Accepted On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData19({
                      ...searchData19,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Accepted On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData19({ ...searchData19, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={acceptedsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>
               {analyticsdatalistdisplay20.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay20} headers={headers20}>Download CSV</CSVLink>
                   </div>
                ):("")}
              {analyticsdatalistdisplay20.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay20}
                    columns={columns20}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                    onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper}>
          <div align="center">
          <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              NPS
            </Typography>
            </div>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="month">Month</InputLabel>
              <Select
                classname={classes.textField}
                labelId="month"
                variant="outlined"
                value={searchData.month}
                onChange={(e) => changemonth(e.target.value)}
              >
                <MenuItem value={"January 2023"}>January 2023</MenuItem>
                <MenuItem value={"February 2023"}>February 2023</MenuItem>
                <MenuItem value={"March 2023"}>March 2023</MenuItem>
                <MenuItem value={"April 2023"}>April 2023</MenuItem>
                <MenuItem value={"May 2023"}>May 2023</MenuItem>
                <MenuItem value={"June 2023"}>June 2023</MenuItem>
                <MenuItem value={"July 2023"}>July 2023</MenuItem>
                <MenuItem value={"August 2023"}>August 2023</MenuItem>
                <MenuItem value={"September 2023"}>September 2023</MenuItem>
                <MenuItem value={"October 2023"}>October 2023</MenuItem>
                <MenuItem value={"November 2023"}>November 2023</MenuItem>
                <MenuItem value={"December 2023"}>December 2023</MenuItem>
                <MenuItem value={"January 2024"}>January 2024</MenuItem>
                <MenuItem value={"February 2024"}>February 2024</MenuItem>
                <MenuItem value={"March 2024"}>March 2024</MenuItem>
                <MenuItem value={"April 2024"}>April 2024</MenuItem>
                <MenuItem value={"May 2024"}>May 2024</MenuItem>
                <MenuItem value={"June 2024"}>June 2024</MenuItem>
                <MenuItem value={"July 2024"}>July 2024</MenuItem>
                <MenuItem value={"August 2024"}>August 2024</MenuItem>
                <MenuItem value={"September 2024"}>September 2024</MenuItem>
                <MenuItem value={"October 2024"}>October 2024</MenuItem>
                <MenuItem value={"November 2024"}>November 2024</MenuItem>
                <MenuItem value={"December 2024"}>December 2024</MenuItem>
                <MenuItem value={"January 2025"}>January 2025</MenuItem>
                <MenuItem value={"February 2025"}>February 2025</MenuItem>
                <MenuItem value={"March 2025"}>March 2025</MenuItem>
                <MenuItem value={"April 2025"}>April 2025</MenuItem>
                <MenuItem value={"May 2025"}>May 2025</MenuItem>
                <MenuItem value={"June 2025"}>June 2025</MenuItem>
                <MenuItem value={"July 2025"}>July 2025</MenuItem>
                <MenuItem value={"August 2025"}>August 2025</MenuItem>
                <MenuItem value={"September 2025"}>September 2025</MenuItem>
                <MenuItem value={"October 2025"}>October 2025</MenuItem>
                <MenuItem value={"November 2025"}>November 2025</MenuItem>
                <MenuItem value={"December 2025"}>December 2025</MenuItem>
                <MenuItem value={"January 2026"}>January 2026</MenuItem>
                                <MenuItem value={"February 2026"}>February 2026</MenuItem>
                                <MenuItem value={"March 2026"}>March 2026</MenuItem>
                                <MenuItem value={"April 2026"}>April 2026</MenuItem>
                                <MenuItem value={"May 2026"}>May 2026</MenuItem>
                                <MenuItem value={"June 2026"}>June 2026</MenuItem>
                                <MenuItem value={"July 2026"}>July 2026</MenuItem>
                                <MenuItem value={"August 2026"}>August 2026</MenuItem>
                                <MenuItem value={"September 2026"}>September 2026</MenuItem>
                                <MenuItem value={"October 2026"}>October 2026</MenuItem>
                                <MenuItem value={"November 2026"}>November 2026</MenuItem>
                                <MenuItem value={"December 2026"}>December 2026</MenuItem>
                                <MenuItem value={"January 2027"}>January 2027</MenuItem>
                                                                <MenuItem value={"February 2027"}>February 2027</MenuItem>
                                                                <MenuItem value={"March 2027"}>March 2027</MenuItem>
                                                                <MenuItem value={"April 2027"}>April 2027</MenuItem>
                                                                <MenuItem value={"May 2027"}>May 2027</MenuItem>
                                                                <MenuItem value={"June 2027"}>June 2027</MenuItem>
                                                                <MenuItem value={"July 2027"}>July 2027</MenuItem>
                                                                <MenuItem value={"August 2027"}>August 2027</MenuItem>
                                                                <MenuItem value={"September 2027"}>September 2027</MenuItem>
                                                                <MenuItem value={"October 2027"}>October 2027</MenuItem>
                                                                <MenuItem value={"November 2027"}>November 2027</MenuItem>
                                                                <MenuItem value={"December 2027"}>December 2027</MenuItem>
              </Select>
              
            </FormControl>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="destination">Destination</InputLabel>
              <Select
                classname={classes.textField}
                labelId="destination"
                variant="outlined"
                value={searchData.destination}
                onChange={(e) => setsearchData({...searchData, destination:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
              </Select>
              
            </FormControl>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="owner">Ops Owner</InputLabel>
              <Select
                classname={classes.textField}
                labelId="owner"
                variant="outlined"
                value={searchData.owner}
                onChange={(e) => setsearchData({...searchData, owner:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                {empops.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              </Select>
              
            </FormControl>
            <Button
                onClick={() =>
                  getclosedTrips()
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <Button
                onClick={() =>
                  getTripsbystartdate()
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search (SD)
              </Button>
            {datalistdisplay? (
                <div style={{ height: 400, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns6}
                    autoPageSize
                    // pageSize={20}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                NPS Details
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData12({
                      ...searchData12,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData12({ ...searchData12, end_date: e.target.value })
                  }
                />
                  {analyticsdatalistdisplay12.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay12} headers={headers12}>Download CSV</CSVLink>
                   </div>
                ):("")}
                <Button
                  onClick={tripsearchbystartdate2}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                <FormControl
                                  style={{
                                    minWidth: 360,
                                    marginTop: 16,
                                    marginRight: 32,
                                    marginLeft: 5,
                                  }}
                                >
                                  <InputLabel id="primary destination">
                                    Review issue
                                  </InputLabel>
                                  <Select
                                    displayEmpty
                                    classname={classes.textField}
                                    labelId="primary destination"
                                    onChange={(e) => setreviewfilter(e.target.value)}
                                  >
                                  <MenuItem value={""}>Clear</MenuItem>
                                   <MenuItem value={"review_hotel_issue"}>review_hotel_issue</MenuItem>
                                   <MenuItem value={"review_land_issue"}>review_land_issue</MenuItem>
                                   <MenuItem value={"review_supplier_issue"}>review_supplier_issue</MenuItem>
                                   <MenuItem value={"review_expectation_issue"}>review_expectation_issue</MenuItem>
                                   <MenuItem value={"review_outside_issue"}>review_outside_issue</MenuItem>
                                   <MenuItem value={"review_knowledge_issue"}>review_knowledge_issue</MenuItem>
                                   <MenuItem value={"review_sales_issue"}>review_sales_issue</MenuItem>
                                   <MenuItem value={"review_support_issue"}>review_support_issue</MenuItem>
                                   <MenuItem value={"review_ops_issue"}>review_ops_issue</MenuItem>
                                   <MenuItem value={"review_communication_issue"}>review_communication_issue</MenuItem>
                                  
                                  </Select>
                                </FormControl>
              </div>
              <div align="center">
                <p>Click and select down to view entire text. 3 means RNG, 0 means RNT and -1 means RNT-G</p>
              </div>
              {analyticsdatalistdisplay12.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay12}
                    columns={columns12}
                    autoPageSize
                    onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
                    pageSize={10}
                    onCellKeyDown={(getValue)=>gridcellkeydown(getValue.row.trip_id, getValue.row.cust_comment)}
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Hotel Issues
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData17({
                      ...searchData17,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData17({ ...searchData17, end_date: e.target.value })
                  }
                />
                  
                <Button
                  onClick={tripsearchbystartdate3}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              
              </div>
              <div align="center">
                <p>Click and select down to view entire text</p>
              </div>
              {analyticsdatalistdisplay18.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay18}
                    columns={columns14}
                    autoPageSize
                    onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
                    pageSize={10}
                    onCellKeyDown={(getValue)=>gridcellkeydown(getValue.row.trip_id, getValue.row.cust_comment)}
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
    </div> );
}
 
export default Marketing;